export const INVITATIONS_LIST_ACTION = "INVITATIONS_LIST_ACTION"

export const invitationsList=(invitations)=>({
    type: INVITATIONS_LIST_ACTION ,
    payload: invitations
});
  